import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { answerSubmission, skipQuestion } from '../actions';
import Canvas from './Canvas';

const mapStateToProps = state => ({
  submission: state.submission,
  next_question: state.next_question
});

const mapDispatchToProp = dispatch => ({
  onAnswer: (question, answer) => {
    dispatch(answerSubmission(question, answer));
  },

  onSkip: () => {
    dispatch(skipQuestion());
  }
});

class Question extends React.Component {
  constructor(props) {
    super(props);
    this.onAnswer = this.onAnswer.bind(this);
  }

  onAnswer(question, answer) {
    this.props.onAnswer(question, answer);
    if (this.props.idx + 1 === this.props.next_question) {
      this.props.onSkip();
    }
  }

  render() {
    const { question, idx, submission, next_question, onSkip } = this.props;

    const answers = question.answers.map((answer, answer_idx) => {
      let result = null;
      if (submission.score && answer_idx === get(submission, `answers.q${question.id}.answer`, null)) {
        result = get(submission, `answers.q${question.id}.correct`, false) ? (<i className="fa fa-check" aria-hidden="true" />) 
          : (<i className="fa fa-times" aria-hidden="true" />);
      }

      return (
        <li key={ answer_idx }>
          <label htmlFor={ `id_q${idx}_a${answer_idx}` }>
            <input type="radio" name={ `question${idx}` } checked={ answer_idx === get(submission, `answers.q${question.id}.answer`, null) } 
              id={ `id_q${idx}_a${answer_idx}` } onChange={() => this.onAnswer(question.id, answer_idx)} disabled={ get(submission, 'submitted', false) } />
            <span dangerouslySetInnerHTML={{ __html: answer }} />
            { result }
          </label>
        </li>
      );
    });

    const skip = next_question === idx + 1 ? (
      <p className="pull-right">
        <a onClick={ onSkip }>SKIP <i className="fa fa-angle-double-right" aria-hidden="true" /></a>
      </p>
    ) : null;

    return (
      <Canvas spanClass="span6 offset1">
        <h2>Question { idx + 1 }</h2>
        <h3 className="question" dangerouslySetInnerHTML={{ __html: question.question }} />                        
        <ul className="choices">{ answers }</ul>                    
        { skip }
      </Canvas>
    );
  }
}

Question.propTypes = {
  question: PropTypes.object,
  idx: PropTypes.number,
  submission: PropTypes.object,
  next_question: PropTypes.number,
  onAnswer: PropTypes.func,
  onSkip: PropTypes.func
};

const QuestionContainer = connect(
  mapStateToProps,
  mapDispatchToProp
)(Question);

export default QuestionContainer;


// WEBPACK FOOTER //
// ./src/components/Question.js